exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-identite .area-image label[data-v-74818ced]{width:90px;height:90px;margin-top:10px;cursor:pointer;position:relative}.content-identite .area-image label img[data-v-74818ced]{margin:0!important}.content-identite .area-image label[data-v-74818ced]:before{transition:all .25s ease-out;content:\" \";position:absolute;width:100%;height:100%;background-color:rgba(0,0,0,.3);top:0;left:0;border-radius:999px;opacity:0;display:inline-block}.content-identite .area-image label[data-v-74818ced]:hover:before{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-74818ced","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/ficheSalarie/salarieLight/salarieLight.scss
// module id = co3r
// module chunks = 2